import {initialPayrollsState, IPayrollsState} from '@app/core/store/state/payrolls.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {EPayrollsActions, PayrollsActions} from '@app/core/store/actions/payrolls.actions';

export const payrollsReducers = (
	state = initialPayrollsState,
	action: PayrollsActions | ErrorActions,
): IPayrollsState => {
	switch (action.type) {
		case EPayrollsActions.GetPayrolls: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EPayrollsActions.GetPayrollsSuccess: {
			return {
				...state,
				isLoading: false,
				payrolls: action.paginationHolder.data,
				pagination: action.paginationHolder.pagination,
			};
		}
		case EPayrollsActions.GetPayrollDetails: {
			return {
				...state,
				isSelectedPayrollLoading: true,
			};
		}
		case EPayrollsActions.GetPayrollDetailsSuccess: {
			return {
				...state,
				isSelectedPayrollLoading: false,
				selectedPayroll: action.payroll,
			};
		}
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		default:
			return state;
	}
};
